import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { showTourLanguageContextMenu } from 'aria-viewer/contextmenu/contextMenuActions'
import ContextButton from './contextButton'
import colors from 'aria-viewer/tour/constants/style/colors'
import Radium from 'radium'
import mapSelectorsToProps from 'aria-viewer/core/selectors/mapSelectorsToProps'

import { MAIN_LANGUAGE_BUTTON_INDEX } from 'aria-viewer/keyboard/constants/tabIndices'

const themes = {
    mobile: {
        languageContainer: {
            display: 'inline-block',
        },
        languageStyle: {
            margin: '0px 0px 0px -30px',
            fontSize: 16,
            fontWeight: 'bold',
            lineHeight: 1.31,
            color: colors.white,
        },
    },
    desktop: {
        theme: 'button_rounded_transparent',
        container: {
            filter: 'drop-shadow( 0px 4px 2px rgba(0, 0, 0, .5))',
            background: 'transparent',
            cursor: 'pointer',
            display: 'inline-block',
            // width: '100%',
            height: '2.5rem',
            marginLeft: 0,
            borderRadius: 0,
            WebkitBackfaceVisibility: 'hidden',
            position: 'relative',
            fontSize: '1em',
            transition: '0.2s ease-out',
            '*': {
                fontSize: '15px',
            },
            ':hover': {
                background: colors.dark_blue,
                // transform: 'scale(1.1)',
            },
            ':active': {
                background: colors.white,
            },
        },
        languageStyle: {
            fontSize: 15,
            margin: 0,
            fontWeight: 700,
            color: colors.white,
            textTransform: 'uppercase',
            position: 'absolute',
            left: '50%',
            top: '50%',
            transform: 'translate(-50%, -50%)',
            ':active': {
                color: '#08131e',
            },
        },
    },
}

class Ptag extends PureComponent {
    render() {
        const { style, language } = this.props

        return (
            <p style={style} aria-label="select language">
                {language}
            </p>
        )
    }
}

const RadiumPtag = Radium(Ptag)

class LanguageButton extends PureComponent {
    render() {
        const {
            languages,
            onClick,
            showTourLanguageContextMenu,
            theme = 'mobile',
            className,
            children,
            contextMenu,
        } = this.props
        const style = themes[theme]

        if (!languages.length || languages.length === 1) return null

        return (
            <ContextButton
                className={className}
                tabIndex={MAIN_LANGUAGE_BUTTON_INDEX}
                theme={style.theme}
                style={{
                    ...style.container,
                    width: contextMenu ? '100%' : '40px',
                    borderRadius: contextMenu ? '0' : '50%',
                    marginLeft: contextMenu ? '0' : '0.5em',
                }}
                setTarget={true}
                alt="language"
                onClick={onClick || showTourLanguageContextMenu}
            >
                <div style={style.languageContainer}>
                    <RadiumPtag style={style.languageStyle} language={this.props.language} />
                </div>

                {children}
            </ContextButton>
        )
    }
}

export default connect(mapSelectorsToProps(['languages']), {
    showTourLanguageContextMenu,
})(LanguageButton)
